import { TicketApprover } from "../ticketApprover/TicketApprover";
import { RequiresApprovalType } from "./RequiresApprovalType";

export interface TicketTypeConfig {
  id: string; // The unique identifier of the ticket type configuration
  ticketModule: string; // The module to which the ticket type belongs (e.g., 'UAR', 'Application Dev')
  ticketType: string; // The type of ticket (e.g., 'User Access Request', 'Report Request')
  description: string; // A brief description of the ticket type
  requiresApprovalType: RequiresApprovalType[]; // Whether the ticket requires approval
  approvers: TicketApprover[]; // List of approver emails
  userEmails: string[]; // List of user emails involved in the ticket process
  emailTemplates: { [key: string]: string }; // Email templates for different stages of the ticket process
  thirdPartyEmails: string[]; // List of third-party emails involved in the ticket process
  actions: string[]; // List of actions to be executed for this ticket type
  jobTitleMapIds: string[]; // List of job title mapping IDs (optional)
}

export function defaultTicketTypeConfig(): TicketTypeConfig {
  return {
    id: "",
    ticketModule: "",
    ticketType: "",
    description: "",
    requiresApprovalType: [],
    approvers: [],
    userEmails: [],
    emailTemplates: {},
    thirdPartyEmails: [],
    actions: [],
    jobTitleMapIds: [],};
}
